import { useLocation } from "react-router-dom";
import { SEO } from "./SEO";
import { getPageMeta } from "@/lib/seo-meta";
import { useIsNotFound } from "@/lib/notFoundSignal";

export const AutoSEO = () => {
  const { pathname } = useLocation();
  const meta = getPageMeta(pathname);
  const isNotFound = useIsNotFound();

  if (isNotFound) return null;
  return <SEO title={meta.title} description={meta.description} isFallback />;
};
